import { render, staticRenderFns } from "./BloodTypeEdit.vue?vue&type=template&id=cfd687ec&scoped=true&"
import script from "./BloodTypeEdit.vue?vue&type=script&lang=js&"
export * from "./BloodTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd687ec",
  null
  
)

export default component.exports